export const fileUpload = {
  label: 'Proof Document(s)',
  uploadArea: 'Drag and drop or click to select .pdf, .jpg, or .png files',
  buttonText: 'Choose File',
};
